module.exports = "https://www.gc-qa.gnp.com.mx/174dd9355f62f4f9cfea961a7cc7d0d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-share.svg
// module id = 978
// module chunks = 0